import { Permission, Unauthentication } from 'components/page/index';
import PERMISSIONS from 'config/app-permission.config';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Enums from 'utils/EnumsManager';
import {
  Attachment,
  ClientDetails,
  Exceptions,
  Invoice,
  ObjectList,
  ObjectShare,
  ObjectTask,
  ObjectView,
  ObjectTaskViewAll,
  Conversion,
  MergeLeads,
  FindDuplicates,
  Dashboard,
  GlobalSearch,
  Task,
  MySetting,
  AttachAccount
} from 'views/index';

const { NotFound } = Exceptions;
const { ObjectTypes, PhantomId } = Enums;
const { Leads, Accounts, Opportunities } = ObjectTypes;

const prefix = ':objectType';

const SetupRoutes = () => (
  <Switch>

    <Route path="/dashboard" component={Dashboard} exact />
    <Route path="/globalSearch" component={GlobalSearch} exact />
    <Route path="/Task" component={Task} exact />
    <Route path="/leads/merge/" component={MergeLeads} />
    <Route path="/my-setting" component={MySetting} />
    <Route
      path="/leads/convert/convert/:objectId"
      render={props => {
    const { match } = props;
    const { objectId } = match.params;
    return <Conversion {...props} objectId={objectId} />;
  }}
    />
    <Route
      path="/accounts/:accountId/opportunities/:objectId"
      render={props => {
    const { match } = props;
    const { accountId, objectId } = match.params;
    return (
      <ClientDetails
        {...props}
        key={`${Opportunities}_${objectId}`}
        accountId={accountId}
        objectId={objectId}
        objectType={Opportunities}
      />
    );
  }}
    />
    <Route
      path="/leads/convert/find/:objectId"
      component={FindDuplicates}
    />
    <Route path="/leads/find/:objectId" component={FindDuplicates} />
    <Route
      path="/:objectType/:objectId/tasks/history/viewAll"
      render={props => <ObjectTaskViewAll objectId={props.match.params.objectId} objectType={props.match.params.objectType} />}
    />
    <Route
      path="/:objectType/sharing/:objectId"
      render={props => {
        const { match } = props;
        const { objectId, objectType } = match.params;
        if ([Leads, Accounts].indexOf(objectType) !== -1) {
          return (
            <ObjectShare
              {...props}
              objectId={objectId}
              objectType={objectType}
            />
          );
        }
        // TOOD: return 404 page
        return null;
      }}
    />
    <Route
      path="/:objectType/:objectId/invoice/:invoiceId"
      component={Invoice}
      exact
    />
    <Route
      path="/:objectType/:objectId/attachments/:attachmentId"
      component={Attachment}
      exact
    />
    <Route
      path="/:objectType/:objectId/tasks/:taskId/completed"
      render={props => <ObjectTask {...props} defaultStateId={1} />}
    />
    <Route
      path="/:objectType/:objectId/tasks/history/:taskId"
      render={props => <ObjectTask {...props} isHistoryTask />}
    />
    <Route path="/:objectType/:objectId/tasks/:taskId" component={ObjectTask} />
    <Route
      path="/:objectType/views/:viewId"
      exact
      render={props => {
        const { match } = props;
        const { objectType, viewId } = match.params;
        if ([Leads, Accounts, Opportunities].indexOf(objectType) !== -1) {
          const pageCode =
            viewId === PhantomId ? 'CREATEVIEWLIST' : 'EDITVIEWLIST';
          const permissionCode =
            PERMISSIONS[`${objectType.toUpperCase()}_${pageCode}`];
          return (
            <Permission
              permission={permissionCode}
              errorComponent={<Unauthentication />}
            >
              <ObjectView {...props} objectType={objectType} />
            </Permission>
          );
        }
        // TOOD: return 404 page
        return null;
      }}
    />
    <Route
      path="/:objectType/:objectId"
      exact
      render={props => {
        const { match } = props;
        const { objectId, objectType } = match.params;
        if ([Leads, Accounts, Opportunities].indexOf(objectType) !== -1) {
          return (
            <ClientDetails
              {...props}
              key={`${objectType}_${objectId}`}
              objectId={objectId}
              objectType={objectType}
            />
          );
        }
        return null;
      }}
    />
    <Route
      path="/:objectType"
      exact
      render={props => {
        const { match } = props;
        const { objectType } = match.params;
        if ([Leads, Accounts, Opportunities].indexOf(objectType) !== -1) {
          const viewCode = PERMISSIONS[`${objectType.toUpperCase()}_VIEW`];
          return (
            <Permission
              permission={viewCode}
              errorComponent={<Unauthentication />}
            >
              <ObjectList key={objectType} {...props} objectType={objectType} />
            </Permission>
          );
        }
        return <NotFound />;
      }}
    />
    <Route
      path="/:objectType/attachAccount/find/:objectId"
      render={() => (
        <Permission permission={PERMISSIONS.OPPORTUNITIES_VIEW}>
          <AttachAccount />
        </Permission>
      )}
    />
  </Switch>
);

export default SetupRoutes;



// WEBPACK FOOTER //
// ./src/components/page/MainContent/components/ObjectRoutes.jsx